import { usePlanFeatureGate } from './use-plan-feature-gate';
import { Features } from '../constants/features';
import { useEnableKlaviyoIntegration } from '../feature-flags/hooks/use-enable-klaviyo-integration';

export const useIntegrationPartnersFeatureGate = () => {
  const { isFeatureEnabled: isQuickbooksIntegrationFeatureEnabled } = usePlanFeatureGate(Features.QuickbooksIntegration);
  const { isFeatureEnabled: isEnhancedReturnsFeatureEnabled } = usePlanFeatureGate(Features.EnhancedReturns);
  const { isFeatureEnabled: isGoogleIntegrationFeatureEnabled } = usePlanFeatureGate(Features.GoogleIntegration);
  const { isFeatureEnabled: isMailChimpIntegrationFeatureEnabled } = usePlanFeatureGate(Features.MailChimpIntegration);
  const { isFeatureEnabled: isWebhooksIntegrationFeatureEnabled } = usePlanFeatureGate(Features.WebhooksIntegration);
  const { isFeatureEnabled: isZapierIntegrationFeatureEnabled } = usePlanFeatureGate(Features.ZapierIntegration);
  const { isFeatureEnabled: isKlaviyoIntegrationFeatureEnabled } = usePlanFeatureGate(Features.KlaviyoIntegration);
  // TODO: remove LD flag before shipping — testing only, plan gate is the long-term gate (FeatureID = 197, Standard/Premium)
  const isKlaviyoFlagEnabled = useEnableKlaviyoIntegration();
  // this included Gorgias, Constant Contact, eDesk, ShipperHQ
  const { isFeatureEnabled: isOtherIntegrationsFeatureEnabled } = usePlanFeatureGate(Features.OtherIntegrations);

  return {
    'Quickbooks Online': isQuickbooksIntegrationFeatureEnabled,
    ReturnRabbit: isEnhancedReturnsFeatureEnabled,
    Google: isGoogleIntegrationFeatureEnabled,
    MailChimp: isMailChimpIntegrationFeatureEnabled,
    Webhooks: isWebhooksIntegrationFeatureEnabled,
    Zapier: isZapierIntegrationFeatureEnabled,
    Klaviyo: isKlaviyoFlagEnabled && isKlaviyoIntegrationFeatureEnabled,
    OtherIntegrations: isOtherIntegrationsFeatureEnabled,
  };
};
